import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppShell } from './AppShell';
import { pickArea } from './areaSwitch';
import { pickSellerNavigation } from '../workspaces/seller/sellerNavigation';
import { selectHasWmsAccess } from '../features/auth/authSelectors';
import { selectHoldsAnyWarehouse } from '../features/warehouseContext/warehouseContextSlice';

export const SellerLayout = () => {
  const { pathname } = useLocation();
  const hasWarehouse = useSelector(selectHasWmsAccess);
  const holdsWarehouse = useSelector(selectHoldsAnyWarehouse);
  const { navigation, inWarehouse } = pickSellerNavigation({
    hasWarehouse,
    holdsWarehouse,
    pathname,
  });
  const { areaLabel, areaSwitch } = pickArea({ hasWarehouse, inWarehouse });

  // Inside the warehouse module the menu is the module's; the sidebar names
  // the side it is on and offers the way across. The order upload is on both.
  return <AppShell navigation={navigation} areaLabel={areaLabel} areaSwitch={areaSwitch} />;
};
